import { z } from 'zod';

const paymentSchema = z.object({
   discount_code: z.string().optional().nullable(),
   auto_renew: z.boolean(),
});

export type TPayment = z.infer<typeof paymentSchema>;

export { paymentSchema };
